// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { DynamicPicklist } from '../'

import { QUERY_DIVISIONS_BY_EMPLOYER } from '../../queries'

import { decodeBase64 } from '../../utils'


export const FilterEmployerDivision = ({ employerId, title, value, onChange, disabled }) => (
  <div className="sidebar__item slds-p-top_medium slds-p-right_large slds-p-bottom_small slds-p-left_large">
    <div className="slds-grid slds-wrap">
      <div className="slds-col slds-size_1-of-1 sidebar__item__title">
        {title}
      </div>
      <div className="slds-col slds-size_3-of-4">
        <div className="sidebar__item__choice">
          <DynamicPicklist
            id='division'
            query={QUERY_DIVISIONS_BY_EMPLOYER}
            field='name'
            params={{
              employer: employerId
                ? decodeBase64(employerId)
                : ''
            }}
            defaultValue='All'
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  </div>
)

FilterEmployerDivision.propTypes = {
  employerId: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

FilterEmployerDivision.defaultProps = {
  employerId: '',
  title: 'Division',
  value: ''
}



// WEBPACK FOOTER //
// ./src/components/filter-employer-division/index.js